var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4971 4.5H7.50293C5.84445 4.5 4.5 5.84445 4.5 7.50293V28.4971C4.5 30.1555 5.84445 31.5 7.50293 31.5H28.4971C30.1555 31.5 31.5 30.1555 31.5 28.4971V7.50293C31.5 5.84445 30.1555 4.5 28.4971 4.5ZM7.50293 6H28.4971C29.3258 6 30 6.67419 30 7.50293V10.5H6V7.50293C6 6.67419 6.67419 6 7.50293 6ZM30 28.4971C30 29.3258 29.3258 30 28.4971 30H7.50293C6.67419 30 6 29.3258 6 28.4971V25.5H30V28.4971ZM30 24H6V18.75H30V24ZM6 17.25V12H30V17.25H6Z",
    fill: "#0278AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion);
export default __webpack_public_path__ + "static/media/version.4d5e920644f0f136a53fe363b9918857.svg";
export { ForwardRef as ReactComponent };